// extracted by mini-css-extract-plugin
export default {"signaturePurchaseModal":"SignaturePurchaseModal_signaturePurchaseModal__PeAOH"};